<template>
  <div role="tablist">
    <p>Buttons</p>
    <draggable
      v-model="pkgButtons.buttons"
      :group="`${device}-btn`"
      handle=".drag-pkg-btn">
      <transition-group>
        <b-card
          v-for="(pkgButton, i) in pkgButtons.buttons"
          :key="`${device}-${i}-btn`"
          class="mb-2"
          no-body>
          <b-card-header
            class="d-flex drag-pkg-btn"
            header-tag="header"
            role="tab">
            <b-icon
              icon="grip-vertical"
              class="align-self-center" />
            <div
              v-b-toggle="`${device}-${i}-pkgbtn`"
              class="pl-1 w-100 d-flex justify-content-between align-items-center"
              @click.prevent="btnOpen = btnOpen === i ? null : i">
              {{ pkgButton.text }}
              <b-icon
                :icon="i === btnOpen ? `chevron-down` : `chevron-right`"
                class="align-self-center ml-auto"
                variant="secondary"
                scale="1.2" />
            </div>
          </b-card-header>
          <b-collapse
            :id="`${device}-${i}-btn`"
            :visible="btnOpen === i"
            :accordion="`${device}-btn`"
            role="tabpanel">
            <b-card-body>
              <b-form-group>
                <b-checkbox
                  v-model="pkgButton.enabled"
                  switch>
                  Enabled
                </b-checkbox>
              </b-form-group>

              <paywall-form-input
                :required="i === 0"
                :device="device"
                label="text"
                :config="pkgButton"
                config-key="text" />
            </b-card-body>
          </b-collapse>
        </b-card>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import PaywallFormInput from "@/components/Paywall/PaywallFormInput"

export default {
  name: "PaywallFormPackageButtons",
  components: {PaywallFormInput, draggable},
  props: {
    pkgButtons: {
      type: Object,
      default: null,
      required: true,
    },
    device: {
      type: String,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      btnOpen: null,
    }
  },
}
</script>

<style scoped>
</style>